import React from 'react';
import './SlidingChoice.css';

export default function SlidingChoice({ value, options, onChange, label }) {
  const index = options.findIndex(option => option.value === value);
  return <div className="sliding-choice" role="group" aria-label={label} style={{ '--choice-index': Math.max(0, index), '--choice-count': options.length }}>
    {index >= 0 && <span className="sliding-choice-indicator" aria-hidden="true" />}
    {options.map(option => <button key={option.value} type="button" aria-pressed={option.value === value} onClick={() => onChange(option.value)}><span>{option.label}</span></button>)}
  </div>;
}
